import { useAuth } from "../providers/auth";
import { useEffect } from "react";

export function useCurrentUserEmployerId() {
  const auth = useAuth();

  useEffect(() => {
    if (
      auth.userClaims?.claims?.type === "E" &&
      !auth.userClaims?.claims?.employerId
    ) {
      // Try refreshing claims
      auth.refreshClaims();
    }
  }, [auth]);

  return auth.userClaims?.claims?.type === "E"
    ? auth.userClaims?.claims?.employerId
    : "";
}
